import CSSPlugin from 'gsapAlias/CSSPlugin'
import { Power1 } from 'gsapAlias/EasePack'
import TimelineLite from 'gsapAlias/TimelineLite'
import TweenLite from 'gsapAlias/TweenLite'

// eslint-disable-next-line no-unused-vars
const plugins = [CSSPlugin]

export const timeline = ({ wgsBar, dnaBar, dnaBarWidth }) => {
  const tl = new TimelineLite({ paused: true })

  tl.add([
    TweenLite.fromTo(
      wgsBar.current,
      1,
      { width: '0%' },
      { width: '100%', ease: Power1.easeOut },
    ),
    TweenLite.fromTo(
      dnaBar.current,
      1,
      { width: '0%' },
      { width: `${dnaBarWidth}%`, ease: Power1.easeOut },
    ),
  ])

  return tl
}
